<template>
  <div class="adaptiveGameReportFilterBar">
    <div class="container-fluid">
      <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
        <div class="col-md-1 col-lg-1 padding-left-3Point3Perc padding-right-0Px text-align-left">
          Group Course(s)
        </div>    
        <div class="col-md-4 col-lg-4">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
              <select class="form-control" v-model="selectedGroupObj">
                <option value='-1' disabled>Select</option>
                <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
              </select> 
            </div>
          </div>
        </div>
        <div class="col-md-1 col-lg-1 text-align-right">
          Cohort(s)
        </div>    
        <div class="col-md-4 col-lg-4 padding-left-0Perc">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
              <select class="form-control" v-model="selectedCohortObj">
                <option value='-1' disabled>Select</option>
                <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
              </select> 
            </div>
          </div>
        </div>
        <div class="col-md-1 col-lg-1 padding-right-0Px padding-left-0Perc">
          <!-- ToDo: Track this -->
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color" v-on:click="checkAndEmit($event, false)">View</button>
        </div>
        <div class="col-md-1 col-lg-1 padding-right-0Px">
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-6px-6px" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState">Export</button>
        </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>      
  </div>
</div>    
</template>

<script>
import isEqual from 'lodash/isEqual'
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import { cohortService } from '@/server-util/cohort-service'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import isEmpty from 'lodash/isEmpty'
export default {
  props: ['showExport'],
  created: function () {
    this.setDefaultValues()
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedM365CourseObj: -1,
      selectedGroupObj: -1,
      selectedCohortObj: -1,
      associatedCohortList: []
    }
  },
  methods: {
    setDefaultValues: function () {
      if (!isEmpty(this.$store.state.selectedGroupCourseObj)) {
        this.selectedGroupObj = this.$store.state.selectedGroupCourseObj
      }
      if (!isEmpty(this.$store.state.selectedCohortObj)) {
        this.selectedCohortObj = this.$store.state.selectedCohortObj
      }
    },
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.selectedGroupObj !== -1) {
        if (this.selectedCohortObj !== -1) {
          // AK: Emit selected MOTD, Group Course and cohort obj
          this.$emit('selectedGroupObj', this.selectedGroupObj)
          this.$emit('selectedCohortObj', this.selectedCohortObj)
          this.$store.state.selectedGroupCourseObj = this.selectedGroupObj
          this.$store.state.selectedCohortObj = this.selectedCohortObj
          if (isExportBtnClicked) {
            this.$emit('isExportBtnClicked', true)
            this.$emit('isViewBtnClicked', false)
          } else {
            this.$emit('isExportBtnClicked', false)
            this.$emit('isViewBtnClicked', true)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a cohort.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedGroupObj.CourseTitle + subTitleName + '\'.'
                this.selectedCohortObj = -1
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      }
    },
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    }
  },
  watch: {
    selectedGroupObj: function () {
      // AK: Reset Selected Cohort Obj to -1 again
      // this.selectedCohortObj = -1
      if (!isEqual(this.selectedGroupObj, this.$store.state.selectedGroupCourseObj)) {
        this.selectedCohortObj = -1
      }
      this.getAssociatedCohortList()
    }
  },
  name: 'adaptiveGameReportFilterBar'
}
</script>

<style scoped>
.adaptiveGameReportFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.text-align-right {
  text-align: right !important;
}
.border-red {
  border: 1px solid red;
}
.padding-6px-6px{
  padding: 6px 6px;
}
.width-auto {
  width: auto;
}
.padding-left-2Point5Perc {
  padding-left: 2.5%;
}
.padding-left-3Perc {
  padding-left: 3%;
}
.width-3Perc {
  width: 3%;
}
.width-13Point4Perc {
  width:13.4%;
}
.padding-left-0Perc {
  padding-left: 0%;
}
.padding-left-3Point3Perc {
  padding-left:3.3%;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/adaptive-game-report/AdaptiveGameReportFilterBar.vue